<template>
  <div class="brand">
    <section-header tag="h1" class="mt-5 mb-5" title="品牌總覽" subtitle="Brands"/>
    <section class="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 pb-5">
      <router-link class="text-decoration-none text-dark" v-for="(brand, index) in brands" :key="index" :to="`/w/brand/detail/${brand.brandId}`">
        <div class="col mb-4">
          <div class="hover-scale-up">
            <div class="image" :style="util.getImageStyle(brand.originalImg)"></div>
          </div>
          <div class="pt-3 pb-3 text-center">{{ brand.brandName }}</div>
        </div>
      </router-link>
    </section>
  </div>
</template>

<script>
import util from '@/util.js'
import constant from '@/constant.js'
import commonApi from '@/api/common.js'
import SectionHeader from '@/components/SectionHeader.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Brand',
  components: {
    SectionHeader
  },
  data: function () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'brands'
    ]),
    util: function () {
      return util
    }
  },
  mounted: function () {
    this.apiGetBrands()
  },
  methods: {
    ...mapMutations([
      'setBrands'
    ]),
    apiGetBrands: function () {
      var self = this
      commonApi.getBrands(function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.setBrands(rspData)
      })
    }
  }
}
</script>

<style scoped>
.image {
  width: 100%;
  padding-bottom: 62%;
  margin: auto;
}
</style>
